var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5705 8.10154L1.57059 8.15929M12.3782 1.45097L12.391 4.78428M5.71156 1.47663L5.72439 4.80994M5.60906 18.1438L12.609 18.1169C14.0091 18.1115 14.7092 18.1088 15.2429 17.8342C15.7124 17.5927 16.0934 17.2088 16.3312 16.7375C16.6017 16.2017 16.599 15.5016 16.5936 14.1015L16.5666 7.10155C16.5612 5.70143 16.5585 5.00137 16.284 4.46764C16.0425 3.99816 15.6586 3.61719 15.1873 3.37932C14.6514 3.10889 13.9514 3.11159 12.5513 3.11698L5.55131 3.14393C4.15119 3.14932 3.45113 3.15202 2.9174 3.42656C2.44792 3.66805 2.06695 4.05197 1.82908 4.52329C1.55865 5.05912 1.56135 5.75918 1.56674 7.1593L1.59369 14.1592C1.59908 15.5594 1.60178 16.2594 1.87632 16.7932C2.11781 17.2626 2.50173 17.6436 2.97305 17.8815C3.50888 18.1519 4.20894 18.1492 5.60906 18.1438Z",
    stroke: "#B8C5CC",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.1262d4d49c53fcb6505fb0baf41b7191.svg";
export { ForwardRef as ReactComponent };